module.exports = __webpack_public_path__ + "img/pc_header_bg.7d54310.webp";